import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { useConnectivity } from '@/hooks/useConnectivity';

export const ConnectionStatusDot = () => {
  const { status, latencyMs, isInitializing, lastCheckedAt } = useConnectivity();

  // During initialization, show a neutral/checking state
  if (isInitializing || !lastCheckedAt) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              role="status"
              className="inline-block w-2 h-2 rounded-full bg-muted-foreground/50"
              aria-label="Checking connection..."
            />
          </TooltipTrigger>
          <TooltipContent side="bottom">
            <p className="text-xs">Checking connection...</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  const statusConfig = {
    online: {
      color: 'bg-green-500',
      label: 'Online',
    },
    degraded: {
      color: 'bg-yellow-500',
      label: latencyMs ? `Slow connection (${Math.round(latencyMs)}ms)` : 'Slow connection',
    },
    offline: {
      color: 'bg-red-500 animate-pulse',
      label: 'Offline',
    },
  };

  const config = statusConfig[status];

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="status"
            className={cn(
              'inline-block w-2 h-2 rounded-full',
              config.color
            )}
            aria-label={config.label}
          />
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p className="text-xs">{config.label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
